import SystemSettingReducer from 'store/system-setting/reducers';

export default SystemSettingReducer;
